export enum TicketStatusEnum {
    Open = 1,
    PreliminaryReport = 2,
    AssignToAgent = 3,
    AgentInquiries = 4,
    ReturnReport = 5,
    AffidavitDrafting = 6,
    Close = 7,
}
